import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { selectSportsbookExploreRecommendedCasinoGamesEnabled } from '~/components/brand/ducks/selectors';
import RecommendedGamesCarousel from '~/components/casino-shared/recommended-carousel/casino-recommended-carousel-async';
import useCasinoRecommendedGames from '~/components/casino-shared/recommended-carousel/use-casino-recommended-games';
import { CasinoRecommendationsKey } from '~/components/casino-shared/recommended-carousel/casino-recommended-constants';
import ExploreTextKeys, { ExploreTranslations } from '../sportsbook-explore-text-keys';
import SportsbookContentHeader from '../../../components/header/sportsbook-content-header';

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	margin-bottom: 20px;
`;

type SportsbookExploreRecommendedCasinoGamesProps = {
	translations: ExploreTranslations;
};

const SportsbookExploreRecommendedCasinoGames: React.FC<SportsbookExploreRecommendedCasinoGamesProps> = ({
	translations
}) => {
	const isEnabled = useSelector(selectSportsbookExploreRecommendedCasinoGamesEnabled);
	const { isLoading, recommendedGames } = useCasinoRecommendedGames(
		CasinoRecommendationsKey.SPORTSBOOK_EXPLORE_KEY,
		isEnabled
	);

	// Feature is not enabled
	if (!isEnabled) {
		return null;
	}

	// Finished loading but no games to show
	if (!isLoading && recommendedGames.length === 0) {
		return null;
	}

	return (
		<Wrapper>
			<SportsbookContentHeader title={translations[ExploreTextKeys.RECOMMENDED_CASINO_GAMES_TITLE]} />
			<RecommendedGamesCarousel
				recommendationsKey={CasinoRecommendationsKey.SPORTSBOOK_EXPLORE_KEY}
				isLoading={isLoading}
				recommendedGames={recommendedGames}
			/>
		</Wrapper>
	);
};

export default SportsbookExploreRecommendedCasinoGames;
